module.exports = __webpack_public_path__ + "img/star.24f671e1.png";